<ion-content scrollY="false">
  <ion-list lines="full">

    @if (order_page.order.status == 'placed') {
      @if (permissionService.isPermitted('pos-orders-payments-add-payment') && (order_page.order.payment_status == 'unpaid' || order_page.order.payment_status == 'partially_paid' || order_page.order.payment_status == 'payment_held')) {
        <ion-item button="true" (click)="presentOrderPaymentModal()">
          <ion-label><fa-icon [icon]="['fal', 'plus']" size="lg" [fixedWidth]="true"></fa-icon>Add payment</ion-label>
        </ion-item>
      }
      @if (permissionService.isPermitted('pos-orders-fulfillments-add-fulfillment') && ((order_page.order.fulfillment_status == 'unfulfilled' || order_page.order.fulfillment_status == 'partially_fulfilled') && order_page.order.fulfillment_status != 'fulfilled' && order_page.order.fulfillable == true)) {
        <ion-item button="true" (click)="presentFulfillmentAddModal()">
          <ion-label><fa-icon [icon]="['fal', 'truck-fast']" size="lg" [fixedWidth]="true"></fa-icon>Fulfill</ion-label>
        </ion-item>
      }
      @if (permissionService.isPermitted('pos-orders-returns-add-return') && (order_page.order.fulfillment_status == 'partially_fulfilled' || order_page.order.fulfillment_status == 'fulfilled') && order_page.order.return_status != 'returned' && order_page.order.returnable == true) {
        <ion-item button="true" (click)="presentReturnAddModal()">
          <ion-label><fa-icon [icon]="['fal', 'hand-holding-box']" size="lg" flip="horizontal" [fixedWidth]="true"></fa-icon>Return</ion-label>
        </ion-item>
      }
      @if (permissionService.isPermitted('pos-orders-refunds-add-refund') && (order_page.order.payment_status == 'partially_paid' || order_page.order.payment_status == 'paid') && order_page.order.refund_status != 'refunded' && order_page.order.refundable == true) {
        <ion-item button="true" (click)="presentRefundAddModal()">
          <ion-label><fa-icon [icon]="['fal', 'hand-holding-usd']" size="lg" [fixedWidth]="true"></fa-icon>Refund</ion-label>
        </ion-item>
      }
      @if (permissionService.isPermitted('pos-orders-email-invoice')) {
        <ion-item button="true" (click)="presentOrderEmailInvoiceModal()">
          <ion-label><fa-icon [icon]="['fal', 'envelope']" size="lg" [fixedWidth]="true"></fa-icon>Email invoice</ion-label>
        </ion-item>
      }
      @if (printer_paper_sizes && printer_paper_sizes.length > 0) {
        @if (permissionService.isPermitted('pos-orders-print-invoice') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
          <ion-item button="true" id="print_invoice" detail="true">
            <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print invoice@if (order_page.order.payment_status != 'unpaid') {
            / receipt
          }</ion-label>
        </ion-item>
        <ion-popover trigger="print_invoice" [dismissOnSelect]="true" side="start">
          <ng-template>
            <ion-content>
              <ion-list lines="full">
                @if (printer_paper_sizes.includes('a4')) {
                  <ion-item button="true" (click)="printOrderInvoice('a4')">
                    <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                  </ion-item>
                }
                @if (printer_paper_sizes.includes('thermal')) {
                  <ion-item button="true" (click)="printOrderInvoice('thermal')">
                    <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                  </ion-item>
                }
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      }
      @if (permissionService.isPermitted('pos-orders-print-invoice') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
        <ion-item button="true" (click)="printOrderInvoice('a4')">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print invoice@if (order_page.order.payment_status != 'unpaid') {
          / receipt
        }</ion-label>
      </ion-item>
    }
    @if (permissionService.isPermitted('pos-orders-print-invoice') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printOrderInvoice('thermal')">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print invoice@if (order_page.order.payment_status != 'unpaid') {
        / receipt
      }</ion-label>
    </ion-item>
  }
  @if (order_page.tickets && order_page.tickets.length) {
    @if (permissionService.isPermitted('pos-orders-print-tickets') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" id="print_tickets" detail="true">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print tickets</ion-label>
      </ion-item>
      <ion-popover trigger="print_tickets" [dismissOnSelect]="true" side="start">
        <ng-template>
          <ion-content>
            <ion-list lines="full">
              @if (printer_paper_sizes.includes('a4')) {
                <ion-item button="true" (click)="printTickets('a4')">
                  <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                </ion-item>
              }
              @if (printer_paper_sizes.includes('thermal')) {
                <ion-item button="true" (click)="printTickets('thermal')">
                  <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                </ion-item>
              }
            </ion-list>
          </ion-content>
        </ng-template>
      </ion-popover>
    }
    @if (permissionService.isPermitted('pos-orders-print-tickets') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printTickets('a4')">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print tickets</ion-label>
      </ion-item>
    }
    @if (permissionService.isPermitted('pos-orders-print-tickets') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printTickets('thermal')">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print tickets</ion-label>
      </ion-item>
    }
  }
  @if (order_page.gift_vouchers && order_page.gift_vouchers.length) {
    @if (permissionService.isPermitted('pos-orders-print-gift-vouchers') && (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" id="print_gift_vouchers" detail="true">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print gift vouchers</ion-label>
      </ion-item>
      <ion-popover trigger="print_gift_vouchers" [dismissOnSelect]="true" side="start">
        <ng-template>
          <ion-content>
            <ion-list lines="full">
              @if (printer_paper_sizes.includes('a4')) {
                <ion-item button="true" (click)="printGiftVouchers('a4')">
                  <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                </ion-item>
              }
              @if (printer_paper_sizes.includes('thermal')) {
                <ion-item button="true" (click)="printGiftVouchers('thermal')">
                  <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                </ion-item>
              }
            </ion-list>
          </ion-content>
        </ng-template>
      </ion-popover>
    }
    @if (permissionService.isPermitted('pos-orders-print-gift-vouchers') && (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printGiftVouchers('a4')">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print gift vouchers</ion-label>
      </ion-item>
    }
    @if (permissionService.isPermitted('pos-orders-print-gift-vouchers') && (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal'))) {
      <ion-item button="true" (click)="printGiftVouchers('thermal')">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print gift vouchers</ion-label>
      </ion-item>
    }
  }
  @if (permissionService.isPermitted('pos-orders-print-xero-invoice') && (order_page.order.xero_invoice_id && !on_device && printer_paper_sizes.includes('a4'))) {
    <ion-item button="true" (click)="printXeroInvoice()">
      <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print Xero invoice</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-orders-print-packing-slip') && (order_page.order.fulfillable == true && printer_paper_sizes.includes('a4'))) {
    <ion-item button="true" (click)="printPackingSlip()">
      <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print packing slip</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-orders-print-delivery-note') && (order_page.order.shipping_address && printer_paper_sizes.includes('a4'))) {
    <ion-item button="true" (click)="printDeliveryNote()">
      <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print delivery note</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-orders-print-collection-note') && (order_page.order.pickup && printer_paper_sizes.includes('a4'))) {
    <ion-item button="true" (click)="printCollectionNote()">
      <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print collection note</ion-label>
    </ion-item>
  }
}
@if (permissionService.isPermitted('pos-orders-edit-order')) {
  <ion-item button="true" (click)="presentOrderEditModal()">
    <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
  </ion-item>
}
@if (permissionService.isPermitted('pos-sell') && permissionService.isPermitted('pos-orders-duplicate-order')) {
  <ion-item button="true" (click)="duplicateOrder()">
    <ion-label><fa-icon [icon]="['fal', 'copy']" size="lg" [fixedWidth]="true"></fa-icon>Duplicate</ion-label>
  </ion-item>
}
}

</ion-list>
</ion-content>
